import { Box, Fab, Grid, Tooltip, Typography } from "@mui/material";
import { useNavigate } from "react-router";

import { useEffect, useState } from "react";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { setUserDetail, setbusinessChooseTab } from "../app/store/reducer";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router/dist";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import PersonIcon from "@mui/icons-material/Person";
import StorefrontIcon from "@mui/icons-material/Storefront";
import TableBarIcon from "@mui/icons-material/TableBar";
import TableRestaurantIcon from "@mui/icons-material/TableRestaurant";
import SearchIcon from "@mui/icons-material/Search";
import HandshakeIcon from "@mui/icons-material/Handshake";
import DashboardIcon from "@mui/icons-material/Dashboard";
import CurrencyRupeeOutlinedIcon from "@mui/icons-material/CurrencyRupeeOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import HeadsetMicOutlinedIcon from "@mui/icons-material/HeadsetMicOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import { routePath } from "../constants/routePath";
import LogOutPop from "./logoutPop";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { capitalizeFirstLetter } from "../app/common/commonFunction";
export default function Analatic() {
  const navigate = useNavigate();
  const headerMenu = useSelector((state) => state.reducer.headerMenu);
  const [header1, setHeader1] = useState([]);
  const [header2, setHeader2] = useState([]);

  // const arrN = (urlHeaderMenu) => {
  //   let arr1 = [...header1];

  //   let arr2 = [...header2];

  //   if (arr1.length == 0) {
  //     urlHeaderMenu.forEach((element, index) => {
  //       if (index % 2 == 0) {
  //         arr1.push(element);
  //       } else {
  //         arr2.push(element);
  //       }
  //       setHeader1(arr1);
  //       setHeader2(arr2);
  //     });
  //   }
  // };
  const businessChooseTab = useSelector(
    (state) => state.reducer.businessChooseTab
  );

  const iconsObj = {
    PersonIcon: PersonIcon,
    StorefrontIcon: StorefrontIcon,
    TableBarIcon: TableBarIcon,
    TableRestaurantIcon: TableRestaurantIcon,
    SearchIcon: SearchIcon,
    HandshakeIcon: HandshakeIcon,
    DashboardIcon: DashboardIcon,
    CurrencyRupeeOutlinedIcon: CurrencyRupeeOutlinedIcon,
    SettingsOutlinedIcon: SettingsOutlinedIcon,
    LockOutlinedIcon: LockOutlinedIcon,
    HeadsetMicOutlinedIcon: HeadsetMicOutlinedIcon,
    ShareOutlinedIcon: ShareOutlinedIcon,
    LogoutOutlinedIcon: PowerSettingsNewIcon,
  };
  const sideBarMenu = useSelector((state) => state.reducer.sideBarMenu);
  const analatics = useSelector((state) => state.reducer.analatics);

  const dispatch = useDispatch();

  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(-1);
  useEffect(() => {
    const indexRoute3 = analatics.findIndex(
      (it) => it.route === location.pathname
    );

    setCurrentPage(indexRoute3);
  }, [location.pathname]);

  return (
    <Grid
      container
      spacing={0}
      sx={{
        // position: "sticky",
        top: "104px",
        pl: "5px",

        background: "#E3E3FF",
        overflowY: "auto",
        height: "auto",
        scrollbarWidth: "thin",
        msOverflowStyle: "none",
        "&::-webkit-scrollbar": {},
        "&::-webkit-scrollbar-thumb": {
          background: (theme) => theme.palette.secondary.main, // Color of the thumb (scrollbar handle)
          borderRadius: "6px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          background: "#FFC107",
        },
      }}
    >
      <Grid sx={{ height: "auto" }} item md={12}>
        {analatics?.map((item, index) => {
          const indexRoute = analatics.findIndex(
            (it) => it.systemFuctionName === item.systemFuctionName
          );
          const IconComponent = iconsObj[analatics[indexRoute]?.icon];

          return (
            <>
              <Box
                key={"siderbar" + index}
                bgcolor="primary"
                sx={{
                  padding:
                    item.systemFuctionName === "Sign Out" ? "4px" : "10px",
                  borderBottom: index !== analatics.length - 1 ? (currentPage === index && item.tab ? "" : "1px solid #ADADCD") : "",
                  background: currentPage === index ? "#E3E3FF" : "",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  fontFamily: "'Montserrat', sans-serif",
                  cursor: "pointer",
                  transition: "0.3s",
                }}
                onClick={async (e) => {
                  navigate(item?.route);

                  dispatch(
                    setbusinessChooseTab(
                      item?.tab?.length > 0
                        ? {
                          value: item?.tab[0].value,
                          label: item?.tab[0].label,
                        }
                        : ""
                    )
                  );
                }}
              >
                

                <Typography
                  variant="standard"
                  color="#01008B"
                  sx={{
                    borderBottom:
                      currentPage === index ? "1px solid #01008B" : "",

                    fontWeight: currentPage === index ? "600" : "400",
                    fontSize: "14px",
                    fontFamily: "'Montserrat', sans-serif",
                  }}
                >
                  {item.label ? item.label : ""  }
                </Typography>
                {item.tab ? (currentPage === index ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />) : ""}
                {/* { item.tab && (currentPage === index ? <ArrowDropDownIcon sx={{color:'#fff'}}/> : <ArrowRightIcon sx={{color:'#fff'}}/>)} */}
              </Box>
              {currentPage === index && item.tab && (
                <>
                  {item?.tab?.map((ele, index) => {
                    if (ele.br) {
                      return (
                        <Box
                          color={
                            businessChooseTab?.value == ele.value
                              ? "#01008B"
                              : "#01008B"
                          }
                          sx={{
                            height: "20px",
                            padding: "10px",
                            fontWeight: "200",
                            fontFamily: "'Montserrat', sans-serif",
                            fontSize: "12px",
                            // marginleft: "2px",
                            color: "#01008B",
                          }}
                        >
                          {capitalizeFirstLetter(ele.label)}
                        </Box>
                      );
                    } else {
                      return (
                        <Box
                          sx={{
                            background:
                              businessChooseTab?.value == ele.value
                                ? "#C0BFFF"
                                : "",
                          }}
                        >
                          <ul>
                            <li style={{ color: "#01008B", fontSize: "12px" }}>
                              <Box
                                onClick={() => {
                                  console.log("{value:ele.value}", {
                                    value: ele.value,
                                  });
                                  dispatch(
                                    setbusinessChooseTab({
                                      value: ele.value,
                                      label: ele.label,
                                    })
                                  );
                                }}
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  cursor: "pointer",
                                  padding: "3px 0px",
                                  transition: "0.5s",
                                  fontFamily: "'Montserrat', sans-serif",
                                }}
                              >
                                <Typography
                                  variant="standard"
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    padding: "10px 0px",
                                  }}
                                  color={
                                    businessChooseTab?.value == ele.value
                                      ? "#01008B"
                                      : "#01008B"
                                  }
                                  textAlign={"left"}
                                >
                                  {capitalizeFirstLetter(ele.label)}
                                </Typography>
                                {/* {businessChooseTab?.value == ele.value && (
                                  <KeyboardArrowRightIcon
                                    sx={{ color: "#fff" }}
                                  />
                                )} */}
                              </Box>
                            </li>
                          </ul>
                        </Box>
                      );
                    }
                  })}
                </>
              )}
            </>
          );
        })}
      </Grid>
      <LogOutPop open={open} setOpen={setOpen} />
    </Grid>
    // </Box>
  );
}
